<template>
  <!-- 系统目录 西成药品 -->
  <div class="MedicenCata">
    <!-- main -->
    <div class="main">
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes"
               style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-b">
            <span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
            <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
      {{ DropDownedName }}<i class="el-icon-down"></i>
    </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown">
                <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- btn2 -->
          <div class="main-icon-c">
            <span
                style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字:</span>
            <el-input size="mini" v-model="searchValue" @keyup.enter.native="handleSearch"></el-input>
          </div>
          <!-- btn3 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                       :style="v.style" @click="handleBtnClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleShowData" ref="tableRef" :key="tableKey">
            <el-table-column
                v-for="(col, inx) in tableRows"
                :key="inx"
                :type="col.type"
                :prop="col.prop"
                :label="col.name"
                align="center"
                :render-header="labelHead"
                :min-width="getColumnWidth(col.label, col.prop, tableData)"
            >
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>

            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <!-- edit -->
            <el-table-column fixed="right" label="操作" width="148"
                             v-if="$store.getters.hasPermission('system:costnametable:edit')">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button type="danger" @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.state === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
        >
        </el-pagination>
      </div>
    </div>
    <!-- feet -->
    <div class="feet">
      <!-- add data 新增 -->
      <!-- messagesBox -->
      <div class="addmessagesBox">
        <el-dialog title="新增" :visible.sync="addChargingVisible" width="50%" :before-close="addEmptyForm"
                   :close-on-click-modal="false" class="patient-dialog">
          <div class="aform">
            <el-tabs type="border-card">
              <el-tab-pane label="标准收费项目">
                <el-form ref="addFormRef" :model="addForm" label-width="100px" size="mini" :rules="rules">
                  <el-row :gutter="20">
                    <!-- 标准项目 -->
                    <el-col :span="8">
                      <el-form-item label="标准项目:" prop="chargeProjectName">
                        <el-select v-model="addForm.chargeProjectName" filterable placeholder="请选择标准项目" clearable
                                   remote
                                   :remote-method="handleChargeProjectSearch"
                                   @change="handleChargeProjectChange"
                                   ref="chargeProjectSelect">
                          <el-option v-for="item in chargeProjectOptions" :key="item.id" :label="item.label" :value="item.id">
                            <span style="float: left; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 费用类别 -->
                    <el-col :span="8">
                      <el-form-item label="费用类别:" prop="expenseCategoryId">
                        <el-select v-model="addForm.expenseCategoryId" filterable placeholder="请选择费用类别" clearable disabled>
                          <el-option v-for="item in costTypeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 财务分类 -->
                    <el-col :span="8">
                      <el-form-item label="财务分类:" prop="financialClassId">
                        <el-select v-model="addForm.financialClassId" filterable placeholder="请选择财务分类" clearable disabled>
                          <el-option v-for="item in financialOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 病案费别 -->
                    <el-col :span="8">
                      <el-form-item label="病案费别:" prop="medicalRecordCostId">
                        <el-select v-model="addForm.medicalRecordCostId" filterable placeholder="请选择病案费别" clearable disabled>
                          <el-option v-for="item in medicalRecordCostOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 拼音简码 -->
                    <el-col :span="8">
                      <el-form-item label="拼音简码:" prop="simpCode">
                        <el-input v-model="addForm.simpCode" placeholder="拼音简码" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 计量单位 -->
                    <el-col :span="8">
                      <el-form-item label="计量单位:" prop="measurementUnit">
                        <el-input v-model="addForm.measurementUnit" placeholder="计量单位" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 规格说明 -->
                    <el-col :span="24">
                      <el-form-item label="规格说明:" prop="description">
                        <el-input v-model="addForm.description" placeholder="规格说明" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 一类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="一类最高价:" prop="oneCeilingPrice">
                        <el-input v-model="addForm.oneCeilingPrice" placeholder="一类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 二类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="二类最高价:" prop="twoCeilingPrice">
                        <el-input v-model="addForm.twoCeilingPrice" placeholder="二类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 三类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="三类最高价:" prop="threeCeilingPrice">
                        <el-input v-model="addForm.threeCeilingPrice" placeholder="三类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 新增表单 -->
          <div class="bform">
            <el-tabs type="border-card">
              <el-tab-pane label="价格信息">
                <el-form ref="addFormRef" :model="addForm" label-width="120px" size="mini" style="margin-top: 12px;" :rules="rules">
                  <el-row :gutter="5">
                    <!-- 项目价格名称 -->
                    <el-col :span="8">
                      <el-form-item label="项目价格名称:" prop="costname">
                        <el-input v-model="addForm.costname" placeholder="项目价格名称"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 医嘱名称 -->
                    <el-col :span="8">
                      <el-form-item label="医嘱名称:" prop="doctorAdviceName">
                        <el-input v-model="addForm.doctorAdviceName" placeholder="医嘱名称" ></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 执行方式 -->
                    <el-col :span="8">
                      <el-form-item label="执行方式:" prop="executemode">
                        <el-select v-model="addForm.executemode" filterable placeholder="请选择执行方式" clearable>
                          <el-option v-for="item in executemodeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 有效状态 -->
                    <el-col :span="8">
                      <el-form-item label="有效状态:" prop="state">
                        <el-select v-model="addForm.state" filterable placeholder="请选择有效状态" clearable>
                          <el-option v-for="item in state" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 执行科室类型 -->
                    <el-col :span="8">
                      <el-form-item label="执行科室类型:" prop="depexecutetype">
                        <el-select v-model="addForm.depexecutetype" filterable placeholder="请选择执行科室类型" clearable>
                          <el-option v-for="item in depexecutetype" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 执行科室 -->
                    <el-col :span="8">
                      <el-form-item label="执行科室:" prop="executedepid">
                        <el-select v-model="addForm.executedepid" filterable placeholder="请选择执行科室" clearable
                                   :disabled="shouldDisableField('addForm', 'executedepid')">
                          <el-option v-for="item in executedepidOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 指导单价 -->
                    <el-col :span="8">
                      <el-form-item label="指导单价:" prop="guidancecost">
                        <el-input v-model="addForm.guidancecost" placeholder="指导单价"
                                  @input="e => handleNumberInput('addForm','guidancecost', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 门诊单价 -->
                    <el-col :span="8">
                      <el-form-item label="门诊单价:" prop="odcost">
                        <el-input v-model="addForm.odcost" placeholder="门诊单价"
                                  @input="e => handleNumberInput('addForm','odcost', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 收费方式 -->
                    <el-col :span="8">
                      <el-form-item label="收费方式:" prop="costmode">
                        <el-select v-model="addForm.costmode" filterable placeholder="请选择收费方式" clearable>
                          <el-option v-for="item in costmode" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 成本金额 -->
                    <el-col :span="8">
                      <el-form-item label="成本金额:" prop="costAmt">
                        <el-input v-model="addForm.costAmt" placeholder="成本金额"
                                  @input="e => handleNumberInput('addForm','costAmt', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 提成金额 -->
                    <el-col :span="8">
                      <el-form-item label="提成金额:" prop="bonusAmt">
                        <el-input v-model="addForm.bonusAmt" placeholder="提成金额"
                                  @input="e => handleNumberInput('addForm','bonusAmt', e)"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="类型:" prop="type">
                        <el-select v-model="addForm.type" filterable placeholder="请选择类型">
                          <el-option v-for="item in typeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 医保名称 -->
                    <el-col :span="12">
                      <el-form-item label="医保名称:" prop="isoname">
                        <el-input v-model="addForm.isoname" placeholder="医保名称">
                          <template #suffix>
                            <el-popover
                                v-model="showPopover"
                                placement="bottom"
                                width="600px"
                                trigger="click"
                            >
                              <el-table :data="costnametableData" size="mini" border
                                        @row-click="handleSelCurrentYbData">
                                <el-table-column v-for="(col, inx) in tableRows2" :key="inx" :type="col.type"
                                                 :prop="col.prop"
                                                 :label="col.name" align="center"
                                                 :render-header="labelHead"
                                                 :min-width="getColumnWidth(col.label,col.prop,costnametableData)">
                                </el-table-column>
                              </el-table>
                              <el-button slot="reference" type="text" style="margin-left: 20px" ref="selYb" @click="handleSelYbCode">选择</el-button>
                            </el-popover>
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 医保编码 -->
                    <el-col :span="12">
                      <el-form-item label="医保编码:" prop="isocode">
                        <el-input v-model="addForm.isocode" placeholder="医保编码"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 备注说明 -->
                    <el-col :span="24">
                      <el-form-item label="备注说明:" prop="remarks">
                        <el-input v-model="addForm.remarks" placeholder="备注说明"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addNewData" size="mini">确定</el-button>
            <el-button @click="addEmptyForm" size="mini">取消</el-button>
          </span>
        </el-dialog>
      </div>

      <!-- edit data 修改 -->
      <!-- 修改对话框（调整为与新增一致） -->
      <div class="editmessagesBox">
        <el-dialog :title="dynamicTitle" :visible.sync="dialogVisible" width="50%" :before-close="cancelUpdateForm"
                   :modal="false" :close-on-click-modal="false" class="patient-dialog">
          <div class="aform">
            <el-tabs type="border-card">
              <el-tab-pane label="标准收费项目">
                <el-form ref="editFormRef" :model="editForm" label-width="100px" size="mini" :rules="rules"
                         :disabled="isLookData">
                  <el-row :gutter="20">
                    <!-- 标准项目 -->
                    <el-col :span="8">
                      <el-form-item label="标准项目:" prop="chargeProjectName">
                        <el-select v-model="editForm.chargeProjectName" filterable placeholder="请选择标准项目"
                                   remote
                                   :remote-method="handleChargeProjectSearch"
                                   @change="handleChargeProjectChangeForEdit"
                                   :disabled="true">
                          <el-option v-for="item in chargeProjectOptions" :key="item.id" :label="item.label" :value="item.id">
                            <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 费用类别 -->
                    <el-col :span="8">
                      <el-form-item label="费用类别:" prop="expenseCategoryId">
                        <el-select v-model="editForm.expenseCategoryId" filterable placeholder="请选择费用类别" clearable disabled>
                          <el-option v-for="item in costTypeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 财务分类 -->
                    <el-col :span="8">
                      <el-form-item label="财务分类:" prop="financialClassId">
                        <el-select v-model="editForm.financialClassId" filterable placeholder="请选择财务分类" clearable disabled>
                          <el-option v-for="item in financialOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 病案费别 -->
                    <el-col :span="8">
                      <el-form-item label="病案费别:" prop="medicalRecordCostId">
                        <el-select v-model="editForm.medicalRecordCostId" filterable placeholder="请选择病案费别" clearable disabled>
                          <el-option v-for="item in medicalRecordCostOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 拼音简码 -->
                    <el-col :span="8">
                      <el-form-item label="拼音简码:" prop="simpCode">
                        <el-input v-model="editForm.simpCode" placeholder="拼音简码" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 计量单位 -->
                    <el-col :span="8">
                      <el-form-item label="计量单位:" prop="measurementUnit">
                        <el-input v-model="editForm.measurementUnit" placeholder="计量单位" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 规格说明 -->
                    <el-col :span="24">
                      <el-form-item label="规格说明:" prop="description">
                        <el-input v-model="editForm.description" placeholder="规格说明" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 一类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="一类最高价:" prop="oneCeilingPrice">
                        <el-input v-model="editForm.oneCeilingPrice" placeholder="一类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 二类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="二类最高价:" prop="twoCeilingPrice">
                        <el-input v-model="editForm.twoCeilingPrice" placeholder="二类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 三类最高价 -->
                    <el-col :span="8">
                      <el-form-item label="三类最高价:" prop="threeCeilingPrice">
                        <el-input v-model="editForm.threeCeilingPrice" placeholder="三类最高价" disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>

          <!-- 价格信息（调整为与新增一致） -->
          <div class="bform">
            <el-tabs type="border-card">
              <el-tab-pane label="价格信息">
                <el-form ref="editFormRef" :model="editForm" label-width="120px" size="mini" style="margin-top: 12px;"
                         :rules="rules" :disabled="isLookData">
                  <el-row :gutter="20">
                    <!-- 项目价格名称 -->
                    <el-col :span="8">
                      <el-form-item label="项目价格名称:" prop="costname">
                        <el-input v-model="editForm.costname" placeholder="项目价格名称" ></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 医嘱名称 -->
                    <el-col :span="8">
                      <el-form-item label="医嘱名称:" prop="doctorAdviceName">
                        <el-input v-model="editForm.doctorAdviceName" placeholder="医嘱名称" ></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 执行方式 -->
                    <el-col :span="8">
                      <el-form-item label="执行方式:" prop="executemode">
                        <el-select v-model="editForm.executemode" filterable placeholder="请选择执行方式" clearable>
                          <el-option v-for="item in executemodeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 有效状态 -->
                    <el-col :span="8">
                      <el-form-item label="有效状态:" prop="state">
                        <el-select v-model="editForm.state" filterable placeholder="请选择有效状态" clearable>
                          <el-option v-for="item in state" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 执行科室类型 -->
                    <el-col :span="8">
                      <el-form-item label="执行科室类型:" prop="depexecutetype">
                        <el-select v-model="editForm.depexecutetype" filterable placeholder="请选择执行科室类型" clearable>
                          <el-option v-for="item in depexecutetype" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 执行科室 -->
                    <el-col :span="8">
                      <el-form-item label="执行科室:" prop="executedepid">
                        <el-select v-model="editForm.executedepid" filterable placeholder="请选择执行科室" clearable
                                   :disabled="shouldDisableField('editForm', 'executedepid')">
                          <el-option v-for="item in executedepidOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 指导单价 -->
                    <el-col :span="8">
                      <el-form-item label="指导单价:" prop="guidancecost">
                        <el-input v-model="editForm.guidancecost" placeholder="指导单价"
                                  @input="e => handleNumberInput('editForm', 'guidancecost', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 门诊单价 -->
                    <el-col :span="8">
                      <el-form-item label="门诊单价:" prop="odcost">
                        <el-input v-model="editForm.odcost" placeholder="门诊单价"
                                  @input="e => handleNumberInput('editForm', 'odcost', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 收费方式 -->
                    <el-col :span="8">
                      <el-form-item label="收费方式:" prop="costmode">
                        <el-select v-model="editForm.costmode" filterable placeholder="请选择收费方式" clearable>
                          <el-option v-for="item in costmode" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 成本金额 -->
                    <el-col :span="8">
                      <el-form-item label="成本金额:" prop="costAmt">
                        <el-input v-model="editForm.costAmt" placeholder="成本金额"
                                  @input="e => handleNumberInput('editForm', 'costAmt', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 提成金额 -->
                    <el-col :span="8">
                      <el-form-item label="提成金额:" prop="bonusAmt">
                        <el-input v-model="editForm.bonusAmt" placeholder="提成金额"
                                  @input="e => handleNumberInput('editForm', 'bonusAmt', e)"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="8">
                      <el-form-item label="类型:" prop="type">
                        <el-select v-model="editForm.type" filterable placeholder="请选择类型">
                          <el-option v-for="item in typeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- 医保名称 -->
                    <el-col :span="12">
                      <el-form-item label="医保名称:" prop="isoname">
                        <el-input v-model="editForm.isoname" placeholder="医保名称">
                          <template #suffix>
                            <el-popover
                                v-model="showPopover"
                                placement="bottom"
                                width="600px"
                                trigger="click"
                            >
                              <el-table :data="costnametableData" size="mini" border
                                        @row-click="handleSelCurrentYbData">
                                <el-table-column v-for="(col, inx) in tableRows2" :key="inx" :type="col.type"
                                                 :prop="col.prop"
                                                 :label="col.name" align="center"
                                                 :render-header="labelHead"
                                                 :min-width="getColumnWidth(col.label,col.prop,costnametableData)">
                                </el-table-column>
                              </el-table>
                              <el-button slot="reference" type="text" style="margin-left: 20px" ref="selYb" @click="handleSelYbCode">选择</el-button>
                            </el-popover>
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 医保编码 -->
                    <el-col :span="12">
                      <el-form-item label="医保编码:" prop="isocode">
                        <el-input v-model="editForm.isocode" placeholder="医保编码"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- 备注说明 -->
                    <el-col :span="24">
                      <el-form-item label="备注说明:" prop="remarks">
                        <el-input v-model="editForm.remarks" placeholder="备注说明"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveEditData" size="mini" :disabled="isLookData">保 存</el-button>
            <el-button @click="cancelUpdateForm" size="mini">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <div class="dialog">
      <el-dialog :title="chargesAddOrEdit" :visible.sync="chargesCollectableDialogVisible" width="50%" :before-close="handleCancelAddChargesCollectable"
                 :modal="false" :close-on-click-modal="false" class="patient-dialog">
        <el-tabs type="border-card">
          <el-tab-pane label="收费项目">
            <el-form :model="addChargesCollectableForm" label-width="100px" size="mini" :rules="addChargesCollectableFormRules" ref="addChargesCollectableFormRef">
              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="编码:" prop="coding">
                    <el-input v-model="addChargesCollectableForm.coding" disabled/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="名称:" prop="chargeProjectName">
                    <el-input v-model="addChargesCollectableForm.chargeProjectName" @input="handleChargesCollectableNameShiftCode"/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="适用对象:" prop="applicableObjects">
                    <el-select v-model="addChargesCollectableForm.applicableObjects" style="width: 100%" filterable clearable>
                      <el-option v-for="item in applicableObjects" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="财务分类:" prop="financialClassId">
                    <el-select v-model="addChargesCollectableForm.financialClassId" style="width: 100%" filterable  @change="handleGetCostTypeByFcId">
                      <el-option v-for="item in financialOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="费用类别:" prop="expenseCategoryId">
                    <el-select v-model="addChargesCollectableForm.expenseCategoryId" style="width: 100%" filterable>
                      <el-option v-for="item in addChargesCostTypeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="病案费别:" prop="medicalRecordCostId">
                    <el-select v-model="addChargesCollectableForm.medicalRecordCostId" style="width: 100%" filterable clearable>
                      <el-option v-for="item in medicalRecordCostOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="一类最高限价:" prop="oneCeilingPrice">
                    <el-input v-model="addChargesCollectableForm.oneCeilingPrice" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="二类最高限价:" prop="twoCeilingPrice">
                    <el-input v-model="addChargesCollectableForm.twoCeilingPrice"/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="三类最高限价:" prop="threeCeilingPrice">
                    <el-input v-model="addChargesCollectableForm.threeCeilingPrice"/>
                  </el-form-item>
                </el-col>

              </el-row>

              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="拼音简码:" prop="simpCode">
                    <el-input v-model="addChargesCollectableForm.simpCode" disabled/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="计量单位:" prop="measurementUnit">
                    <el-input v-model="addChargesCollectableForm.measurementUnit"/>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="有效状态:" prop="state">
                    <el-select v-model="addChargesCollectableForm.state" style="width: 100%" filterable clearable>
                      <el-option v-for="item in state" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-row>

              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="物价编码:" prop="priceCode">
                    <el-input v-model="addChargesCollectableForm.priceCode"/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="国家贯标编码:" prop="standardCode">
                    <el-input v-model="addChargesCollectableForm.standardCode"/>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="国家贯标名称:" prop="standardName">
                    <el-input v-model="addChargesCollectableForm.standardName"/>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="8">
                <el-col :span="24">
                  <el-form-item label="项目内涵:" prop="projectConnotatio">
                    <el-input v-model="addChargesCollectableForm.projectConnotatio" type="textarea" :rows="3"/>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="除外内容:" prop="excludedContent">
                    <el-input v-model="addChargesCollectableForm.excludedContent" type="textarea" :rows="3"/>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注:" prop="remake">
                    <el-input v-model="addChargesCollectableForm.remake" type="textarea" :rows="3"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary"  size="mini" @click="handleAddOrEditChargesCollectable">保 存</el-button>
          <el-button @click="handleCancelAddChargesCollectable" size="mini">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 接口
import {
  addChargePrice,
  costnametablePage,
  getAttribute,
  getChargingPriceById,
  getServiceCatalog,
  standardList,
  updateChargePrice
} from "@/api/Outpatient/chargingPrice.js";
import { pinyin } from "pinyin-pro";
import { withLoading } from "@/untils/loading";
import { addChargeProject, updateChargeProject } from "@/api/Outpatient/category";
import dayjs from "dayjs";
import { getChargingPrice } from "@/api/cosrute/Cosrute";
import { getOneFinancialSummaryAccountById } from "@/api/financialSummaryManagement/financialSummaryAccount";

// 工厂函数：生成空的新增表单
const getEmptyAddForm = () => ({
  id: null,
  applicableObjects: null,
  chargeProjectName: "",
  chstype: null,
  costid: null,
  costmode: 0,
  costname: "",
  depexecutetype: 2,
  description: "",
  doctorAdviceName: "",
  executedepid: null,
  executemode: 1,
  expenseCategoryId: null,
  finClassCode: "",
  financialClassId: null,
  guidancecost: null,
  hospcost: null,
  isocode: "",
  isoname: "",
  measurementUnit: "",
  medicalRecordCostId: null,
  odcost: null,
  oneCeilingPrice: null,
  priceCode: "",
  remarks: "",
  selfproportion: null,
  simpCode: "",
  state: 1,
  threeCeilingPrice: null,
  twoCeilingPrice: null,
  type: null,
  costAmt: null,
  bonusAmt: null,
});

// 工厂函数：生成空的新增收费项目表单
const getEmptyChargesCollectableForm = () => ({
  applicableObjects: null,
  chargeProjectName: "",
  clinicId: null,
  coding: dayjs().format('YYYYMMDDHHmmss'),
  description: "",
  excludedContent: "",
  expenseCategoryId: null,
  finClassCode: "",
  financialClassId: null,
  id: null,
  measurementUnit: "",
  medicalRecordCostId: null,
  oneCeilingPrice: null,
  operatingPeople: null,
  operatingTime: "",
  priceCode: "",
  projectConnotatio: "",
  remake: "",
  simpCode: "",
  standardCode: "",
  standardName: "",
  state: 1,
  threeCeilingPrice: null,
  twoCeilingPrice: null,
});

// 工具函数：生成拼音简码
const generatePinyinCode = (name) => {
  if (!name) return "";
  return pinyin(name, {
    pattern: 'first',
    toneType: 'none',
    separator: ''
  }).toLocaleUpperCase();
};

// 工具函数：数字输入过滤（保留数字和小数点）
const filterNumberInput = (value) => {
  return value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
};

export default {
  data() {
    const validateNumber = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('不能为空'));
      } else if (isNaN(Number(value))) {
        callback(new Error('必须为数字'));
      } else {
        callback();
      }
    };

    return {
      // 基础数据
      searchValue: '',
      CatalogueName: '项目价格',
      DropDownedName: '全部',
      iconComes: 'el-icon-charging',

      // 状态控制
      loading: false,
      dialogVisible: false,
      addChargingVisible: false,
      isLookData: false,
      chargesCollectableDialogVisible: false,
      chargesAddOrEdit: '',
      dynamicTitle: '',
      showPopover: false,

      // 分页数据
      pageNum: 1,
      pageSize: 8,
      totalSize: 0,

      // 表单数据
      addForm: getEmptyAddForm(),
      editForm: {},
      addChargesCollectableForm: getEmptyChargesCollectableForm(),

      // 验证规则
      rules: {
        chargeProjectName: [{ required: true, message: '收费项目名称不能为空', trigger: 'blur' }],
        executemode: [{ required: true, message: '执行方式不能为空', trigger: 'change' }],
        applicableObjects: [{ required: true, message: '适用对象不能为空', trigger: 'change' }],
        expenseCategoryId: [{ required: true, message: '费用类别不能为空', trigger: 'change' }],
        costname: [{ required: true, message: '费用名称不能为空', trigger: 'blur' }],
        doctorAdviceName: [{ required: true, message: '医嘱名称不能为空', trigger: 'blur' }],
        state: [{ required: true, message: '状态不能为空', trigger: 'change' }],
        depexecutetype: [{ required: true, message: '执行类型不能为空', trigger: 'change' }],
        executedepid: [{
          required: true,
          message: '执行科室不能为空',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.addForm.depexecutetype === 0 && !value) {
              callback(new Error('执行科室不能为空'));
            } else {
              callback();
            }
          }
        }],
        guidancecost: [{ required: true, validator: validateNumber, trigger: 'blur' }],
        odcost: [{ required: true, validator: validateNumber, trigger: 'blur' }],
        costmode: [{ required: true, message: '收费方式不能为空', trigger: 'change' }],
        type: [{ required: true, message: '类型不能为空', trigger: 'change' }],
      },

      addChargesCollectableFormRules: {
        chargeProjectName: [{ required: true, message: ' ', trigger: 'change' }],
        coding: [{ required: true, message: ' ', trigger: 'change' }],
        expenseCategoryId: [{ required: true, message: ' ', trigger: 'change' }],
        financialClassId: [{ required: true, message: ' ', trigger: 'change' }],
        medicalRecordCostId: [{ required: true, message: ' ', trigger: 'change' }],
      },

      // 按钮配置
      headerBtn: [
        { search: "search", title: "搜索", type: "success" },
        { add: "add", title: "新增", type: "warning", auth: 'system:costnametable:add' },
      ],

      // 下拉选项（静态）
      typeOptions: [
        { id: 1, label: '理疗' },
        { id: 2, label: '治疗' },
        { id: 3, label: '检查' },
        { id: 4, label: '检验' },
        { id: 5, label: '挂号费' },
        { id: 6, label: '其他' }
      ],

      depexecutetype: [
        { id: 0, label: '固定执行科室' },
        { id: 1, label: '病人所在科室' },
        { id: 2, label: '操作员所在科室' }
      ],
      executemodeOptions: [
        { id: 0, label: '否' },
        { id: 1, label: '是' }
      ],
      costmode: [
        { id: 0, label: '标准单价' },
        { id: 1, label: '手工定价' },
        { id: 2, label: '处方划价' }
      ],
      state: [
        { id: 1, label: '可用' },
        { id: 0, label: '禁用' }
      ],
      chstype: [
        { id: 1, label: '甲类' },
        { id: 2, label: '乙类' },
        { id: 3, label: '丙类' },
        { id: 4, label: '特检特治' }
      ],
      applicableObjects: [
        { id: 0, label: '全部' },
        { id: 1, label: '门诊' },
        { id: 2, label: '住院' },
        { id: 3, label: '门诊和住院' },
        { id: 4, label: '打包明细' }
      ],

      // 动态下拉选项
      chargeProjectOptions: [],
      costTypeOptions: [],
      financialOptions: [],
      medicalRecordCostOptions: [],
      executedepidOptions: [],
      addChargesCostTypeOptions: [],

      // 表格列配置
      tableRows: [
        { name: "医嘱名称", prop: "doctorAdviceName", type: "" },
        { name: "收费方式", prop: "costmode", type: "", op: "costmode" },
        { name: "项目价格名称", prop: "costname", type: "" },
        { name: "指导单价", prop: "guidancecost", nz: "nz" },
        { name: "门诊单价", prop: "odcost", type: "" },
        { name: "执行科室", prop: "executedepid", type: "", op: "executedepid" },
        { name: "操作时间", prop: "createTime", type: "" },
        { name: "操作人", prop: "createStaffName", nz: "nz" },
        { name: "修改时间", prop: "updateTime", type: "" },
        { name: "修改人", prop: "updateStaffName", type: "" },
        { name: "备注说明", prop: "remarks", type: "" },
      ],
      tableRows2: [
        { name: "医保编码", prop: "medicalCode", type: "" },
        { name: "医保名称", prop: "medicalServiceName", type: "" },
        { name: "开始时间", prop: "startTime" },
        { name: "结束时间", prop: "endTime", type: "" },
      ],

      // 其他数据
      tableKey: 0,
      tableData: [],
      costnametableData: [],
      userInfo: null,
      pageDataState: null,
      currentNode: null,
    };
  },

  mounted() {
    this.initPage();
  },

  methods: {
    // 初始化
    async initPage() {
      await this.loadData();
      this.costTypeOptions = this.$store.getters['preload/getCostTypeOptions'] || [];
      this.financialOptions = this.$store.getters['preload/getFinancialOptions'] || [];
      this.medicalRecordCostOptions = this.$store.getters['preload/getMedicalRecordCostOptions'] || [];
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    },

    // 加载表格数据
    async loadData() {
      const res = await costnametablePage({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchValue || '',
        state: this.pageDataState,
        expenseCategoryId: this.currentNode,
      });

      if (res.code === 200) {
        this.tableData = res.data.content.map(item => ({
          ...item,
          expenseCategoryId: parseInt(item.expenseCategoryId),
          odcost: Number(item.odcost).toFixed(2),
          guidancecost: Number(item.guidancecost).toFixed(2),
          costAmt: Number(item.costAmt).toFixed(2),
          bonusAmt: Number(item.bonusAmt).toFixed(2),
          hospcost: Number(item.hospcost).toFixed(2),
          executedepid: item.executedepid === 0 ? '' : item.executedepid,
        }));
        this.totalSize = res.data.totalSize;
        this.pageSize = res.data.pageSize;
        this.tableKey++;
        await this.loadExecutedepidOptions();
      }
    },

    // 加载执行科室选项（缓存避免重复请求）
    async loadExecutedepidOptions() {
      const res = await getAttribute();
      this.executedepidOptions = res.data.map(v => ({ id: v.id, label: v.deptName }));
    },

    // 搜索
    async handleSearch() {
      await this.loadData();
    },

    // 按钮点击
    handleBtnClick(i) {
      if (i === 0) this.handleSearch();
      else if (i === 1) this.handleAdd();
    },

    // 新增按钮
    handleAdd() {
      this.addChargingVisible = true;
      this.resetAddForm();
    },

    resetAddForm() {
      this.addForm = getEmptyAddForm();
      this.$refs.addFormRef?.resetFields();
    },

    // 收费项目搜索
    async handleChargeProjectSearch(query) {
      const res = await standardList({ name: query });
      this.chargeProjectOptions = res.data.map(v => ({ label: v.chargeProjectName, id: v.id, ...v }));
    },

    // 收费项目选择（新增）
    async handleChargeProjectChange(projectId) {
      const selected = this.chargeProjectOptions.find(item => item.id === projectId);
      if (!selected) return;

      this.addForm = {
        ...this.addForm,
        costid: selected.id,
        chargeProjectName: selected.chargeProjectName,
        simpCode: generatePinyinCode(selected.chargeProjectName),
        expenseCategoryId: parseInt(selected.expenseCategoryId),
        applicableObjects: selected.applicableObjects,
        oneCeilingPrice: selected.oneCeilingPrice,
        twoCeilingPrice: selected.twoCeilingPrice,
        threeCeilingPrice: selected.threeCeilingPrice,
        measurementUnit: selected.measurementUnit,
        description: selected.description,
        costname: selected.chargeProjectName,
        state: 1,
        doctorAdviceName: selected.chargeProjectName,
        guidancecost: selected.threeCeilingPrice,
        odcost: selected.threeCeilingPrice,
        priceCode: selected.priceCode,
        financialClassId: selected.financialClassId,
        medicalRecordCostId: selected.medicalRecordCostId,
      };
      await this.loadMedicalInsuranceInfo(selected.chargeProjectName);
    },

    // 收费项目选择（编辑）
    async handleChargeProjectChangeForEdit(projectId) {
      const selected = this.chargeProjectOptions.find(item => item.id === projectId);
      if (!selected) return;

      this.editForm = {
        ...this.editForm,
        costid: selected.id,
        chargeProjectName: selected.chargeProjectName,
        simpCode: generatePinyinCode(selected.chargeProjectName),
        expenseCategoryId: parseInt(selected.expenseCategoryId),
        applicableObjects: selected.applicableObjects,
        oneCeilingPrice: selected.oneCeilingPrice,
        twoCeilingPrice: selected.twoCeilingPrice,
        threeCeilingPrice: selected.threeCeilingPrice,
        measurementUnit: selected.measurementUnit,
        description: selected.description,
        costname: selected.chargeProjectName,
        type: selected.type,
        doctorAdviceName: selected.chargeProjectName,
        priceCode: selected.priceCode,
        financialClassId: selected.financialClassId,
        medicalRecordCostId: selected.medicalRecordCostId,
      };
    },

    // 加载医保信息
    async loadMedicalInsuranceInfo(projectName) {
      const res = await getServiceCatalog({ name: projectName, pageSize: 50 });
      if (res.code === 200) {
        this.costnametableData = res.data;
        this.showPopover = true;
      } else {
        this.$message.error("系统异常:获取该项目医保信息失败");
      }
    },

    // 数字输入处理
    handleNumberInput(formName, field, value) {
      const clean = filterNumberInput(value);
      this.$set(this[formName], field, clean);
      this.checkValues(formName, field);
    },

    // 成本/提成校验
    checkValues(formName, field) {
      const form = this[formName];
      const costAmt = parseFloat(form.costAmt) || 0;
      const guidancecost = parseFloat(form.guidancecost) || 0;
      const bonusAmt = parseFloat(form.bonusAmt) || 0;

      if (field === 'costAmt' && costAmt > guidancecost) {
        this.$message.error('成本金额不能大于指导单价');
        this.$set(form, 'costAmt', guidancecost);
      }
      if (field === 'bonusAmt' && bonusAmt > costAmt) {
        this.$message.error('提成金额不能大于成本金额');
        this.$set(form, 'bonusAmt', costAmt);
      }
    },

    // 控制执行科室禁用
    shouldDisableField(formName, field) {
      if (field === 'executedepid') {
        const form = this[formName];
        if (form.depexecutetype === 1 || form.depexecutetype === 2) {
          this.$set(form, 'executedepid', null);
          return true;
        }
      }
      return false;
    },

    // 表格映射
    safeGetMappedValue(col, row) {
      const raw = row[col.prop];
      if (raw === null || raw === undefined) return '';
      if (!col.op || !Array.isArray(this[col.op])) return raw;
      const match = this[col.op].find(item => item.id == raw);
      return match?.label ?? raw;
    },

    // 启用/禁用
    async handleStartOrDisabled(row) {
      const action = row.state === 1 ? '禁用' : '启用';
      try {
        await this.$confirm(`请确认是否${action}当前选项`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await withLoading(this, `${action}处理中...`)(async () => {
          this.editForm = { ...row, state: row.state === 0 ? 1 : 0 };
          const res = await updateChargePrice(this.editForm);
          if (res.code === 200) {
            await this.loadData();
            this.$message.success(`${action}成功`);
          } else {
            this.$message.error(res.message);
          }
        });
      } catch {
        this.$message.info("已取消操作");
      }
    },

    // 查看详情
    async handleShowData(row) {
      await this.loadEditFormData(row, true);
    },

    // 编辑
    async handleClickEdit(row) {
      await this.loadEditFormData(row, false);
    },

    // 加载编辑表单数据
    async loadEditFormData(row, isView = false) {
      this.dynamicTitle = isView ? '查看' : '编辑';
      this.isLookData = isView;

      const res = await standardList({ name: row.costname });
      const project = res.data.find(item => item.id === row.costid) || {};

      this.editForm = {
        ...row,
        costid: project.id,
        type: row.type,
        priceCode: project.priceCode,
        description: project.description,
        oneCeilingPrice: project.oneCeilingPrice,
        twoCeilingPrice: project.twoCeilingPrice,
        chargeProjectName: project.chargeProjectName,
        threeCeilingPrice: project.threeCeilingPrice,
        applicableObjects: project.applicableObjects,
        medicalRecordCostId: project.medicalRecordCostId,
        finClassCode: project.finClassCode || '',
        financialClassId: project.financialClassId || null,
        simpCode: generatePinyinCode(project.chargeProjectName || row.costname),
      };
      this.dialogVisible = true;
    },

    // 保存编辑
    async saveEditData() {
      try {
        await this.$refs.editFormRef.validate();

        const chargingPrice = await getChargingPriceById(this.editForm.id);
        const currentType = chargingPrice.data.depexecutetype;
        const newType = this.editForm.depexecutetype;
        if ((newType === 1 || newType === 2) && currentType === 0) {
          this.editForm.executedepid = 0;
        }

        await withLoading(this, '修改处理中...')(async () => {
          const res = await updateChargePrice(this.editForm);
          if (res.code === 200) {
            await this.getChargingPriceOptions();
            this.dialogVisible = false;
            await this.loadData();
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.message);
          }
        });
      } catch (error) {
        if (error !== 'cancel') this.$message.warning("请填写完整表单");
      }
    },

    // 新增保存
    async addNewData() {
      try {
        await this.$refs.addFormRef.validate();
        if (this.addForm.depexecutetype === 0 && !this.addForm.executedepid) {
          this.$message.warning("请选择固定执行的科室!");
          return;
        }
        await withLoading(this, '数据提交中...')(async () => {
          const res = await addChargePrice(this.addForm);
          if (res.code === 200) {
            this.addChargingVisible = false;
            await this.getChargingPriceOptions();
            await this.loadData();
            this.$message.success("新增成功");
          } else {
            this.$message.error(res.message);
          }
        });
      } catch (error) {
        if (error !== 'cancel') this.$message.warning("请填写完整表单");
      }
    },

    // 获取收费价格选项并存入 store
    async getChargingPriceOptions() {
      const res = await getChargingPrice();
      this.$store.commit('preload/updatePreloadData', {
        key: 'getChargingPriceOptions',
        data: res.data.map(item => ({
          id: item.id,
          label: item.costname,
          odcost: item.odcost,
          executedepid: item.executedepid,
          depexecutetype: item.depexecutetype,
          executemode: item.executemode,
          costmode: item.costmode
        }))
      });
    },

    // 状态下拉切换
    async handleCommand(command) {
      this.pageDataState = command === 'a' ? 1 : command === 'b' ? 0 : null;
      this.DropDownedName = command === 'a' ? '可用' : command === 'b' ? '禁用' : '全部';
      await this.loadData();
    },

    addEmptyForm() {
      this.resetAddForm();
      this.addChargingVisible = false;
    },

    cancelUpdateForm() {
      this.dialogVisible = false;
      this.isLookData = false;
      this.editForm = {};
      this.$refs.editFormRef?.resetFields();
    },

    // 医保编码选择
    async handleSelYbCode() {
      const projectName = this.addChargingVisible ? this.addForm.costname : this.editForm.costname;
      const res = await getServiceCatalog({ name: projectName, pageSize: 50 });
      if (res.code === 200) {
        this.costnametableData = res.data;
        this.showPopover = true;
      } else {
        this.$message.error("系统异常:获取该项目医保信息失败");
      }
    },

    handleSelCurrentYbData(row) {
      const form = this.addChargingVisible ? this.addForm : this.editForm;
      form.isocode = row.medicalCode;
      form.isoname = row.medicalServiceName;
      this.showPopover = false;
    },

    handleChargesCollectableNameShiftCode() {
      this.addChargesCollectableForm.simpCode = generatePinyinCode(this.addChargesCollectableForm.chargeProjectName);
    },

    async handleGetCostTypeByFcId(financialClassId) {
      const res = await getOneFinancialSummaryAccountById(financialClassId);
      if (res.code === 200) {
        if (!res.data.costtypeList?.length) {
          this.addChargesCollectableForm.expenseCategoryId = null;
          this.addChargesCostTypeOptions = [];
          return;
        }
        this.addChargesCostTypeOptions = res.data.costtypeList.map(item => ({
          id: item.id,
          label: item.name,
          applyobject: item.applyobject
        }));
      } else {
        this.$message.error(res.message);
      }
    },

    async handleAddOrEditChargesCollectable() {
      try {
        await this.$refs.addChargesCollectableFormRef.validate();
        await withLoading(this, '数据提交中...')(async () => {
          const isAdd = !this.addChargesCollectableForm.id;
          const api = isAdd ? addChargeProject : updateChargeProject;
          const res = await api(this.addChargesCollectableForm);
          if (res.code === 200) {
            this.handleCancelAddChargesCollectable();
            await this.handleChargeProjectSearch('');
            this.$message.success(isAdd ? "新增成功" : "修改成功");
          } else {
            this.$message.error(res.message);
          }
        });
      } catch {
        this.$message.warning("请填写完整表单");
      }
    },

    handleOpenAddChargesCollectable() {
      this.chargesAddOrEdit = '新增收费项目';
      this.chargesCollectableDialogVisible = true;
      this.addChargesCollectableForm = getEmptyChargesCollectableForm();
    },

    handleOpenEditChargesCollectable(row) {
      this.chargesAddOrEdit = '修改收费项目';
      this.addChargesCollectableForm = {
        ...row,
        state: 1,
        coding: row.priceCode,
        simpCode: generatePinyinCode(row.chargeProjectName)
      };
      this.chargesCollectableDialogVisible = true;
    },

    handleCancelAddChargesCollectable() {
      this.addChargesCollectableForm = getEmptyChargesCollectableForm();
      this.$refs.addChargesCollectableFormRef?.clearValidate();
      this.chargesCollectableDialogVisible = false;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格自适应宽度辅助函数
    getColumnWidth(label, prop, tableData) {
      if (!tableData?.length) return 120;
      const minWidth = 100;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },

    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>

<style lang="less" scoped>
/* 下拉菜单样式 */
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}
/* 原有的样式保持不变 */
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 180px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    max-height: 70vh !important;
    height: auto !important;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0;

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .aform, .bform {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 5px;
        min-height: 0;

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0;

          .el-tabs__content {
            flex: 1;
            overflow: visible;
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0;

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

.MedicenCata {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;
        }
      }

      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }
    }
  }

  .feet {
    .addmessagesBox {
      .aform {
        margin-top: 12px;
      }

      .bform {
        margin-top: 12px;
      }
    }
  }
}
</style>